export const hiddenSectionOf = (
  key: string,
  hiddenGroups: { key: string; columnKeys: string[] }[],
  fallbackSection: string
) =>
  hiddenGroups.find(({ columnKeys }) => columnKeys.includes(key))?.key ??
  fallbackSection
